import { FC, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { authManager } from 'services/auth';
import { EASSpinner } from 'components/EASSpinner';

export const RecurringAuth: FC = () => {
	const { search } = useLocation();
	const navigate = useNavigate();

	const handledRef = useRef(false);

	// Same-origin frames share the tab's sessionStorage, so a framed callback would consume the
	// handshake the top-level document is waiting on and leave it looking like a state mismatch.
	// The silent flow has its own page; nothing legitimate drives this one from inside a frame.
	const isFramed = window.self !== window.top;

	useEffect(() => {
		if (isFramed || handledRef.current) return;
		handledRef.current = true;

		authManager
			.handleAuthorizationCallback(search)
			.then((returnTo) => navigate(returnTo, { replace: true }))
			.catch(() => navigate('/login', { replace: true }));
	}, [search, navigate, isFramed]);

	if (isFramed) return null;

	return <EASSpinner />;
};
